// extracted by mini-css-extract-plugin
var _1 = "PostSectionHeader-module__animateUploadProgressBarWidth--I7wrH";
var _2 = "PostSectionHeader-module__animatedBackground--RYGVn";
var _3 = "PostSectionHeader-module__canShrink--y2vEW";
var _4 = "PostSectionHeader-module__content--VhLHL";
var _5 = "PostSectionHeader-module__controls--tNo_Z";
var _6 = "PostSectionHeader-module__header--_0YNF";
var _7 = "PostSectionHeader-module__subtopicContent--TdtcQ";
var _8 = "PostSectionHeader-module__subtopicTitleLink--M4JRA";
var _9 = "PostSectionHeader-module__subtopicWrapper--H3OUb";
var _a = "PostSectionHeader-module__title--G2e7z";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "canShrink", _4 as "content", _5 as "controls", _6 as "header", _7 as "subtopicContent", _8 as "subtopicTitleLink", _9 as "subtopicWrapper", _a as "title" }
